// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  initFreeGiftsChoices();
  var freeShippingBar = document.querySelector('.free-shipping-bar');
  if(typeof freeShippingBar != 'undefined' && freeShippingBar != null) {
    console.log(freeShippingBar);
  }
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */

document.addEventListener("DOMContentLoaded", function() {
  initFreeGiftsChoices();
  //Find refreshcart
  let refreshCart, cartInstance, initFreeShippingBar;
  for(const instance of Shopify.theme.sections.instances) {
    if(instance.container.classList.contains('quick-cart')) {
      cartInstance = instance;
      refreshCart = instance.refreshQuickCart;
      initFreeShippingBar = instance._initFreeShippingBar;
      break;
    }
  }

  var playVideoBtns = document.querySelectorAll('.play-video');
  var playBtns = [];

  if(playVideoBtns.length > 0) {
    playVideoBtns.forEach(function(btn, i) {
      playBtns[i] = btn;
  
      playBtns[i].addEventListener('click', function(e){
        var videoId = playBtns[i].dataset.videoId;
        console.dir(playBtns[i]);
        var videoWrapper = document.getElementById(videoId);
        playBtns[i].classList.toggle('playing');
        
        if(videoWrapper.paused) {
          videoWrapper.play();
        } else {
          videoWrapper.pause();
        }
      });
    });
  }

  var showDescBtn = document.querySelector('.btn-show-description');

  if(typeof showDescBtn != 'undefined' && showDescBtn != null) {
    var seeMore = showDescBtn.dataset.seeMore || 'See more details';
    var seeLess = showDescBtn.dataset.seeLess || 'See less details';
    showDescBtn.addEventListener('click', function(e){
      e.preventDefault();

      showDescBtn.parentElement.classList.toggle('show-full');

      showDescBtn.innerText = showDescBtn.innerText == seeMore ? seeLess : seeMore ;
    });
  }

  var goodForBtn = document.querySelector('.trigger-wigf');

  if(typeof goodForBtn != 'undefined' && goodForBtn != null) {
    goodForBtn.addEventListener('click', function(){
      goodForBtn.parentElement.classList.toggle('open');
    });
  }

  document.addEventListener("cart:updated", function (evt) {
    var cart = evt.detail.cart;
    
    setTimeout(function() {
      var freeShippingBar = document.querySelector('.free-shipping-bar');
      var freegiftchoice = document.querySelector('.free-gift-multiple-choice');
      if(typeof freeShippingBar != 'undefined' && freeShippingBar != null) {
        initFreeGiftsChoices();
        var threshold = parseFloat(freeShippingBar.dataset.giftThreshold) * 100;
        var variantId = freeShippingBar.dataset.freeGiftId;
        var variantPrice = parseFloat(freeShippingBar.dataset.freeGiftValue);
        var freegiftadded = false;
        var totalcart = cart.total_price;
        
        if(variantId) {
          cart.items.forEach(function(item) {
            if(item.properties) {          
              for (const property in item.properties) {
                  if(property == '_free_gift') {
                    freegiftadded = true;
                    totalcart = totalcart - variantPrice;
                  }
              }      
            }
          });
    
          if(totalcart >= threshold && !freegiftadded) {
            let formData = {
              'items': [{
                'id': variantId,
                'quantity': 1,
                'properties': {
                  '_free_gift': 'yes'
                }
                }]
            };
            
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            }).then((data) => {
              console.log("Product added", data);
              refreshCart.call(cartInstance);
            });
      
          } else if(totalcart < threshold && freegiftadded) {
            let updates = {};
            updates[variantId] = 0;
            
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            }).then((data) => {
                console.log("Product removed", data);
                refreshCart.call(cartInstance);
                initFreeShippingBar.call(cartInstance);
            });
            
          }
        } else if(typeof freegiftchoice != 'undefined' && freegiftchoice != null) {
          console.log("test");
          var freeItemId;
  
          cart.items.forEach(function(item) {
            if(item.properties) {          
              for (const property in item.properties) {
                  if(property == '_free_gift') {
                    freeItemId = item.id;
                    freegiftadded = true;
                    totalcart = totalcart - parseFloat(item.final_price);
                  }
              }      
            }
          });
  
          if(totalcart >= threshold && !freegiftadded) {
            freegiftchoice.classList.add('show');
          } else if(totalcart < threshold && freegiftadded) {          
            let updates = {};
            updates[freeItemId] = 0;
            
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            }).then((data) => {
                console.log("Product removed", data);
                refreshCart.call(cartInstance);
                initFreeShippingBar.call(cartInstance);
            });
          } else if(totalcart < threshold) {
            freegiftchoice.classList.remove('show');
          } else if(freegiftadded) {
            freegiftchoice.classList.remove('show');
          }
        }
      } else {
        console.log('not freeshipping bar');
      }
    }, 500);    
  });

  function initFreeGiftsChoices() {
    const freeGiftWrapper = document.querySelector('.free-gift-multiple-choice');
    
    if(typeof freeGiftWrapper != 'undefined' && freeGiftWrapper != null) {
      console.log("loading free gift choices");
      const freeGiftBtnsArr = freeGiftWrapper.querySelectorAll('.cross-sells__item-add');
      let freeGiftBtns = [];

      freeGiftBtnsArr.forEach(function(el, index) {
        freeGiftBtns[index] = el;

        freeGiftBtns[index].addEventListener('click', function() {
          freeGiftBtns[index].classList.add('loading');
          const variantId = freeGiftBtns[index].dataset.addItemId;

          let formData = {
            'items': [{
             'id': variantId,
             'quantity': 1,
             'properties': {
                '_free_gift': 'yes'
              }
             }]
           };
           
           fetch(window.Shopify.routes.root + 'cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json'
             },
             body: JSON.stringify(formData)
           })
           .then(response => {
             return response.json();
           })
           .catch((error) => {
             freeGiftBtns[index].classList.remove('loading');
             console.error('Error:', error);
           }).then((data) => {
            freeGiftBtns[index].classList.remove('loading');
            freeGiftWrapper.classList.remove('show');
            refreshCart.call(cartInstance);
            console.log("Product added", data);
           });
        });
      })
    }
  }

  //Free gift JS
  

  // var freeGiftDiv = document.querySelector('.free-gift-bar');

  // if(typeof freeGiftDiv != 'undefined' && freeGiftDiv != null) {
  //   var threshold = parseFloat(freeGiftDiv.dataset.threshold) * 100;
  //   var thresholdDiff = 0;
  //   var percentage = 0;
  //   var freegiftbar = freeGiftDiv.querySelector('.free-shipping-bar__bar');
  //   var freegiftmessage = freeGiftDiv.querySelector('.free-shipping-bar__message');
  //   var variantId = freeGiftDiv.dataset.variantId;
    
  //   document.addEventListener("cart:updated", function (evt) {
  //     var cart = evt.detail.cart;

  //     if(cart.total_price >= threshold) {
        
  //       if(!freeGiftDiv.classList.contains('completed')) {
  //         freeGiftDiv.classList.add('completed');
  //         percentage = 100;
  //         freegiftbar.style = "--progress-width: " + percentage + "%;";
  //         freegiftmessage.innerHTML = 'Your order qualifies for free gift!';

  //         let formData = {
  //           'items': [{
  //            'id': variantId,
  //            'quantity': 1,
  //            'properties': {
  //               '_free_gift': 'yes'
  //             }
  //            }]
  //          };
           
  //          fetch(window.Shopify.routes.root + 'cart/add.js', {
  //            method: 'POST',
  //            headers: {
  //              'Content-Type': 'application/json'
  //            },
  //            body: JSON.stringify(formData)
  //          })
  //          .then(response => {
  //            return response.json();
  //          })
  //          .catch((error) => {
  //            console.error('Error:', error);
  //          }).then((data) => {
  //           console.log("Product added", data);
  //          });
           
  //       }
  //     } else {
  //       if(freeGiftDiv.classList.contains('completed')) {
  //         freeGiftDiv.classList.remove('completed');
  //         let updates = {};
  //         updates[variantId] = 0;
  //         fetch(window.Shopify.routes.root + 'cart/update.js', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify({ updates })
  //         })
  //         .then(response => {
  //           return response.json();
  //         })
  //         .catch((error) => {
  //           console.error('Error:', error);
  //         }).then((data) => {
  //           console.log("Product removed", data);
  //         });
  //       }
  //       thresholdDiff = (threshold - cart.total_price) / 100;
  //       thresholdDiff = (Math.round(thresholdDiff * 100) / 100).toFixed(2);;
  //       percentage = (cart.total_price / threshold) * 100;
  //       freegiftmessage.innerHTML = 'Only <span class="fs-body-bold">$'+ thresholdDiff +'</span> away from a free gift!';
  //       freegiftbar.style = "--progress-width: " + percentage + "%;";
  //     }
  //   });
  // }
});